/* eslint-disable xss/no-mixed-html */
// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './app/store';  // Ensure store is imported correctly
import './fonts.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>  {/* Pass children to Provider */}
    <App />
  </Provider>
);
